import { configureStore } from '@reduxjs/toolkit';
// import { api } from './api';
import { setupListeners } from '@reduxjs/toolkit/query';
import configReducer from './slice/configSlice';

export const store = configureStore({
  reducer: {
    // [api.reducerPath]: api.reducer,
    config: configReducer,
  },
  // middleware: (getDefaultMiddleware) =>
  //   getDefaultMiddleware().concat(api.middleware),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
